
import { Vue } from 'vue-property-decorator';
export default class ErrorPanel extends Vue {
  private get errorMessage(): string {
    return this.$t('err.load');
  }

  private handleClick(): void {
    this.$emit('retryClicked');
  }
}
